module.exports = __webpack_public_path__ + "img/pin_take_away_orange.cba8ed62.svg";